import { Table } from 'antd'
import React from 'react'

export default function BillableAccountPreviewTable({ data, blank }) { 
  return (
      <Table dataSource={data} rowKey={(r) => r.id}>
        <Table.Column title="Account Number" key="account_number" dataIndex="account_number" />
        {/* <Table.Column title="Facility - Number - Division Name" key="facility" dataIndex={!blank ? "facility" : ""} />
        <Table.Column title="Vendor - Accounting Number - Routing Number - Payment Method" key="vendor" dataIndex={!blank ? "vendor" : ""} /> */}
        <Table.Column title="Facility Name" key="facility_name" dataIndex={!blank ? "facility_name" : ""} />
        <Table.Column title="Facility Number" key="facility_number" dataIndex={!blank ? "facility_number" : ""} />
        <Table.Column title="Vendor Name" key="vendor" dataIndex={!blank ? "vendor" : ""} />
        <Table.Column title="Vendor Short Code" key="vendor_short_code" dataIndex={!blank ? "vendor_short_code" : ""} />
        <Table.Column title="Utility Service" key="utility_service" dataIndex={!blank ? "utility_service" : ""} />
        <Table.Column title="Name" key="name" dataIndex={!blank ? "name" : ""} />
        <Table.Column title="Tax ID" key="tax_id" dataIndex={!blank ? "tax_id" : ""} />
        <Table.Column title="Street Address 1" key="street_address_1" dataIndex={!blank ? "street_address_1" : ""} />
        <Table.Column title="Street Address 2" key="street_address_2" dataIndex={!blank ? "street_address_2" : ""} />
        <Table.Column title="City" key="city" dataIndex={!blank ? "city" : ""} />
        <Table.Column title="State" key="state" dataIndex={!blank ? "state" : ""} />
        <Table.Column title="Zipcode" key="zip" dataIndex={!blank ? "zip" : ""} />
        <Table.Column title="Mailing Address" key="mailing_address" dataIndex={!blank ? "mailing_address" : ""} />
        <Table.Column title="Mailing Zipcode" key="mailing_zipcode" dataIndex={!blank ? "mailing_zipcode" : ""} />
        <Table.Column title="Mailing City" key="mailing_city" dataIndex={!blank ? "mailing_city" : ""} />
        <Table.Column title="Mailing State" key="mailing_state" dataIndex={!blank ? "mailing_state" : ""} />
        <Table.Column title="Billing Period" key="billing_period" dataIndex={!blank ? "billing_period" : ""} />
        <Table.Column title="Account Pay Method" key="pay_method" dataIndex={!blank ? "pay_method" : ""} />
        <Table.Column title="Notes" key="note" dataIndex={!blank ? "note" : ""} />
        <Table.Column title="Active" key="active" dataIndex={!blank ? "active" : ""} render={(_, record) => !blank ? record.active ? "TRUE" : "FALSE" : ''}/>
      </Table>
  )
}
